<template>
  <div
    class="success-page"
    :style="{ width: '100%', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }"
  >
    <c-card
      v-if="!settingsService.loading.value && settingsService.settings.value.supportsMarketingCampaign1 === undefined && showCampaign"
      :style="{ position: 'fixed', top: '5vh', left: '1.5rem', height: '90vh', width: 'calc(100vw - 3rem)', fontSize: '1.6rem' }"
      class="_support-us"
    >
      <c-container
        :style="{ overflowX: 'hidden' }"
        padding-size="small"
      >
        <div class="_avatars">
          <c-avatar
            src="/app/images/patrick.jpeg"
            size="60px"
            class="_avatar"
          />
          <c-avatar
            src="/app/images/seb.jpeg"
            size="60px"
            class="_avatar"
          />
        </div>
        <div class="_text">
          <p>
            Hi there, Patrick and Seb here, the creators of Notix.
          </p>
          <p>
            We need your help! Would you support us with a review in the Chrome Web Store?
          </p>
          <p>
            It only takes a minute. <a
              class="_link"
              target="_blank"
              href="https://chromewebstore.google.com/detail/fmnbhafoldgblmdmhflflnjlfjcgpnog/reviews"
            >
              Write review now
            </a>
          </p>
        </div>
        <c-divider />
        <c-button
          :style="{ marginTop: '2rem' }"
          stretch
          color="primary"
          @click="saveSupportResponse(true)"
        >
          Done!
        </c-button>
        <c-button
          :style="{ marginTop: '2rem' }"
          outlined
          stretch
          color="light"
          @click="saveSupportResponse(false)"
        >
          Sorry, Patrick and Seb, I'm out
        </c-button>
      </c-container>
    </c-card>
    <div :style="{ width: '80%' }">
      <c-icon
        type="check-mark-circle-filled"
        :color="$colors.grey.darken2"
        size="60"
      />
      <c-button
        :style="{ marginTop: '4rem' }"
        stretch
        color="primary"
        @click="goToPage"
      >
        Open in Notion
      </c-button>
      <c-button
        :style="{ marginTop: '2rem' }"
        stretch
        color="light"
        @click="copyLink"
      >
        Copy link
      </c-button>
      <c-button
        :style="{ marginTop: '2rem' }"
        stretch
        color="light"
        @click="$emit('leave')"
      >
        Back to templates
      </c-button>
    </div>
  </div>
</template>

<script>
import CAvatar from 'shared/components/CAvatar.vue';
import CButton from 'shared/components/CButton.vue';
import CCard from 'shared/components/CCard.vue';
import CContainer from 'shared/components/CContainer.vue';
import CDivider from 'shared/components/CDivider.vue';
import CIcon from 'shared/components/CIcon.vue';
import useSettings from 'shared/services/settings';
import {
  FIREBASE_APP,
  SUBSCRIPTION_MANAGER,
  USER_SERVICE,
} from 'shared/constants';
import { inject } from 'vue';

export default {
  name: 'SuccessPage',
  props: {
    response: {
      type: Object,
      required: true,
    },
  },
  emits: ['leave'],
  components: { CIcon, CButton, CCard, CAvatar, CContainer, CDivider },
  data() {
    return { showCampaign: false };
  },
  setup() {
    const firebaseApp = inject(FIREBASE_APP);
    const userService = inject(USER_SERVICE);
    const subscriptionManager = inject(SUBSCRIPTION_MANAGER);
    const settingsService = useSettings(firebaseApp.db, userService.currentUser, subscriptionManager);
    return { settingsService };
  },
  computed: {
    pageId() {
      return this.response.id.replaceAll('-', '');
    },
    link() {
      return `https://notion.so/${this.pageId}`;
    },
  },
  methods: {
    goToPage() {
      window.open(this.link, '_blank');
    },
    copyLink() {
      window.parent.postMessage({ msg: 'NOTIX_COPY_TO_CLIPBOARD', payload: this.link }, '*');
      this.$eventBus.emit('show-toast', { message: 'Link copied to clipboard' });
    },
    saveSupportResponse(value) {
      this.settingsService.save({ supportsMarketingCampaign1: value });
    },
  },
  created() {
    this.settingsService.init();
    setTimeout(() => {
      this.showCampaign = true;
    }, 400);
  },
};
</script>

<style scoped lang="scss" type="text/scss">
._support-us {
  display: flex;
  align-items: center;

  ._link {
    text-decoration: underline;
    color: $link-color;
  }

  ._avatars {
    display: flex;
    align-items: center;
    justify-content: center;

    ._avatar {
      &:first-of-type {
        margin-right: -1.4rem;
      }
    }
  }
}
</style>
